import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import SportsTrainingPost from "../../../components/sports-training-post"
import theme from "../../../theme"

const summary = [
  {
    level: "Beginner",
    frequency: "2 to 3 short sessions",
    focus: "Dribbling, layups, footwork, passing, shooting form",
    weeklyHabit: "Start close to the basket and build clean technique",
  },
  {
    level: "Developing player",
    frequency: "3 sessions plus game",
    focus: "Ball handling, finishing, set shooting, defence, spacing",
    weeklyHabit: "Practise both skill work and small-sided decision-making",
  },
  {
    level: "Competitive player",
    frequency: "4 sessions plus game",
    focus: "Game-speed shooting, weak hand, screen reads, conditioning",
    weeklyHabit: "Track makes from key spots and train at match tempo",
  },
  {
    level: "Advanced player",
    frequency: "4 to 6 sessions with recovery",
    focus: "Strength, speed, film review, role-specific skills, late-game execution",
    weeklyHabit: "Pair hard court days with mobility, shooting touch, or recovery",
  },
]

const sections = [
  {
    title: "Beginner: learn the movement patterns",
    paragraphs: [
      "Beginner basketball training should include dribbling with both hands, simple passing, layup footwork, close-range shooting, and defensive stance games.",
      "Players should start near the basket. Clean shooting form from close range is more valuable than throwing long shots with poor mechanics.",
    ],
  },
  {
    title: "Developing player: add decisions",
    paragraphs: [
      "Developing players need a mix of skill repetition and small-sided play. Use drills that connect ball handling, passing, spacing, cutting, and finishing.",
      "Defence belongs in the routine too: stance, slides, close-outs, rebounding position, and communication can be trained in short focused blocks.",
    ],
  },
  {
    title: "Competitive player: train at game speed",
    paragraphs: [
      "Competitive players should practise shooting after movement, finishing through contact, weak-hand handling, screen reads, and transition decisions.",
      "Track a few simple numbers, such as corner makes, free throws, or left-hand finishes. Measurement keeps practice honest without making it complicated.",
    ],
  },
  {
    title: "Advanced player: build the whole week",
    paragraphs: [
      "Advanced basketball training needs court work, strength, speed, mobility, film review, and recovery. Every hard session should have a purpose.",
      "A shared calendar helps separate shooting volume, team training, gym work, games, and lighter recovery days so the athlete does not train flat every session.",
    ],
  },
]

const BasketballTrainingRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Basketball Training Schedule by Skill Level"
        description="Plan basketball training for beginners through advanced players with routines for ball handling, shooting, defence, conditioning, and recovery."
      />
      <SportsTrainingPost
        sport="Basketball"
        title="Basketball training routines for different levels"
        intro="A strong basketball routine balances skill repetition with game-speed decisions, defensive habits, athletic development, and recovery."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/quick-termite-63"
        image="blog-basketball.png"
        imageAlt="Basketball training planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default BasketballTrainingRoutines
